export enum GroupEventsNameE {
  JOIN_ROOMS = 'join-rooms',
  NEW_GROUP = 'new-group',
  SYNC_GROUP = 'sync-group',
  MESSAGE_GROUP = 'message-group',
  LEAVE_ROOMS = 'leave-rooms',
  MESSAGE_STATUS_CHANGE = 'message-status-change',
  DELETE_MESSAGE = 'set-deleted-message',
  MESSAGE_TRANSCRIPTION_GROUP = 'message-transcription-group',
  UPDATE_GROUP = 'update-group',
  DELETE_GROUP = 'delete-group',
  GROUP_CREATE_FAILED = 'group-create-failed',
  UPDATE_GROUP_PARTICIPANTS = 'update-group-participants',
  CREATE_GROUP_STEP_CALL_INITIATED = 'create-group-step-call-initiated',
  NEW_GROUP_MENTIONS = 'new-group-mentions',
}
